import React, {Component} from 'react'
import PropTypes from 'prop-types'
import timeHumanize from "../../../helpers/timeHumanize"
import {Button, PopoverBody, PopoverHeader, UncontrolledPopover} from "reactstrap"
import ObjectInspector from "react-inspector"

class HistoryRow extends Component {
    render() {
        const {item, index} = this.props
        const {_id, created_at, user_created, user_ip, meta, action, user_note} = item

        return (
            <tr key={_id}>
                <td className="colID">{index + 1}</td>
                <td className="colTime">{timeHumanize(created_at)}</td>
                <td className="colUser">{user_created}</td>
                <td className="colIP">{user_ip}</td>
                <td className="colMeta">
                    <Button id={`mypopover_${_id}`} color="link">
                        <code>{action}</code>
                    </Button>
                    <UncontrolledPopover target={`mypopover_${_id}`} trigger="legacy">
                        <PopoverHeader><code>{action}</code></PopoverHeader>
                        <PopoverBody>
                            <ObjectInspector depth={0} path="root.value"
                                             data={meta !== undefined ? (Object.keys(meta).length === 0 ? '--' : meta) : '--'}/>
                        </PopoverBody>
                    </UncontrolledPopover>
                </td>
                <td className="colNote">{user_note}</td>
            </tr>
        )
    }
}

HistoryRow.propTypes = {
    item: PropTypes.object,
    index: PropTypes.number
}

export default HistoryRow